<template>
  <div class="tab-box flex flex-around flex-column bg-2">
    <img src="../../assets/images/35.png" class="img">
    <div class="lottery-content">
      <div class="lottery-box">
        <span class="lottery-item" :class="{'active': item.prize_id == lotteryIndex}" v-for="item in prize_arr" :key="item.prize_id">
          <img :src="item.prize_img" :alt="item.prize_name" class="full-img">
        </span>
        <span class="position-center lottery-btn" @click="getDrawInfoFn"></span>
      </div>
    </div>
    <img src="../../assets/images/38.png" class="img-38">
  </div>
</template>

<script>
import Lottery from '../../utils/lottery'

export default {
  name: 'Lottery',
  data () {
    return {
      lotteryObj: null,
      lotteryIndex: 1,
      flag: false
    }
  },
  computed: {
    prize_arr () {
      return this.$store.state.drawInfo.prize_arr || []
    }
  },
  inject: ['slideHandle', 'infoHandle', 'msgHandle'],
  methods: {
    setLottery (res) {
      this.lotteryObj = new Lottery({
        turnIng: e => {
          this.lotteryIndex = e
        },
        turnEnd: () => {
          if (res.prize_status === 1) {
            this.infoHandle(true, 'false')
          } else {
            this.msgHandle(true)
          }
          this.flag = false
        }
      })
      this.lotteryObj.start(res.prize_id)
    },
    getDrawInfoFn () {
      if (this.flag) return false
      this.flag = true
      this.$alert.load()
      this.$http.getDrawInfo().then(res => {
        this.$alert.close()
        if (res.status === 1) {
          this.$store.setState('prize_title', res.result.prizeInfo.prize_title)
          this.$store.setState('drawInfo', res.result.drawInfo)
          this.setLottery(res.result.prizeInfo)
        } else {
          this.flag = false
          this.$alert.warn(res.msg)
        }
      })
    }
  },
  created () {
    this.$store.state.pageName = 'Lottery'
  },
  mounted () {

  },
  beforeDestroy () {

  }
}
</script>

<style scoped>
.tab-box {
  padding: 2vh 0;
}
.img-38 {
  display: block;
  width: 5.98rem;
}
.lottery-content {
  position: relative;
  width: 6.28rem;
  height: 6.4rem;
  background: url('../../assets/images/36.png') center no-repeat;
  background-size: 100% 100%;
}
.lottery-box {
  position: absolute;
  top: .45rem;
  right: 0;
  left: 0;
  width: 5.4rem;
  height: 5.4rem;
  margin: auto;
}
.lottery-item {
  position: absolute;
  width: 1.75rem;
  height: 1.75rem;
  z-index: 10;
  border-radius: .2rem;
  background-color: #feedef;
  box-shadow: inset 0 -0.2rem 0 #fecbd0;
  overflow: hidden;
}
.lottery-item:nth-child(1) {
  top: 0;
  left: 0;
}
.lottery-item:nth-child(2) {
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: #ffced3;
  box-shadow: inset 0 -0.2rem 0 #ff9fa8;
}
.lottery-item:nth-child(3) {
  top: 0;
  right: 0;
}
.lottery-item:nth-child(4) {
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background-color: #ffced3;
  box-shadow: inset 0 -0.2rem 0 #ff9fa8;
}
.lottery-item:nth-child(5) {
  right: 0;
  bottom: 0;
}
.lottery-item:nth-child(6) {
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: #ffced3;
  box-shadow: inset 0 -0.2rem 0 #ff9fa8;
}
.lottery-item:nth-child(7) {
  bottom: 0;
  left: 0;
}
.lottery-item:nth-child(8) {
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: #ffced3;
  box-shadow: inset 0 -0.2rem 0 #ff9fa8;
}
.lottery-item.active {
  background-color: #ffcf54;
  box-shadow: inset 0 -0.2rem 0 #ffc74c;
}
.lottery-btn {
  width: 2.14rem;
  height: 2.07rem;
  background: url('../../assets/images/37.png') center no-repeat;
  background-size: contain;
}
</style>
